<template>
  <div class="lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto">
    <div class="AddNodeNameColor-topCurve-wrapper lxn-w100">
      <CustomCurve>
          <TopNav @leftTextClick="goBack" :leftText="$store.getters.language.texts.LoginRegister_back" leftIcon="arrowLeft" centerText="" rightText=""></TopNav>
      </CustomCurve>
    </div>
    <div class="AddNodeNameColor-main-wrapper lxn-pos-rel lxn-margin-auto lxn-border-round">
      <WrapperSvgTitleText>
        <template v-slot:svg>
          <svg viewBox="0 0 113.39 113.39">
            <g transform="translate(175.085 -251.936)">
              <path class="AddNodeNameColor-st0" d="M-154.39,251.94h72c11.43,0,20.69,9.26,20.69,20.69v72c0,11.43-9.26,20.69-20.69,20.69h-72c-11.43,0-20.69-9.26-20.69-20.69v-72C-175.09,261.2-165.82,251.94-154.39,251.94z"/>
              <path class="AddNodeNameColor-st1" d="M-77.48,353.99c0,0-15.68,2.86-40.91,2.86s-40.91-2.86-40.91-2.86c-2.46,0-4.45-1.99-4.45-4.45c0,0-2.86-15.68-2.86-40.91s2.86-40.91,2.86-40.91c0-2.46,1.99-4.45,4.45-4.45h0c0,0,15.68-2.86,40.91-2.86s40.91,2.86,40.91,2.86c2.46,0,4.45,1.99,4.45,4.45l0,0c0,0,2.86,15.68,2.86,40.91s-2.86,40.91-2.86,40.91C-73.03,352-75.02,353.99-77.48,353.99C-77.48,353.99-77.48,353.99-77.48,353.99z"/>
            </g>
            <path :style="'fill: ' + $store.state.themeMainColors[activeBoxIndex]" d="M69.32,44.02c-3.48-3.48-9.12-3.48-12.6,0c-2.71,2.71-3.39,6.86-1.67,10.29L41.23,68.13l-0.01,3.99l7.73,0.01v-3.76h3.76v-3.76h3.76v-3.76l2.56-2.56c4.4,2.2,9.75,0.42,11.95-3.98C72.7,50.88,72.03,46.73,69.32,44.02z M66.49,50.66c-1.05,1.05-2.76,1.05-3.81,0s-1.05-2.76,0-3.81c1.05-1.05,2.76-1.05,3.81,0c0,0,0,0,0,0C67.54,47.91,67.54,49.61,66.49,50.66z"/>
          </svg>
        </template>
        <template v-slot:title>
          {{$store.getters.language.texts.AddNodeNameColor_title}}
        </template>
        <template v-slot:text>
          {{$store.getters.language.texts.AddNodeNameColor_text}}
        </template>
      </WrapperSvgTitleText>
    </div>
    <div class="AddNodeNameColor-wrapper-inputs lxn-margin-auto lxn-border-round">
      <div class="AddNodeNameColor-input-spacer">
      </div>
      <customInput v-model="NodeName" @focus="inputState='active'" @blur="inputState=''" :inputState="inputState" :placeHolder="$store.getters.language.texts.AddNodeNameColor_placeHolder" inputType="text">
      </customInput>
      <div class="AddNodeNameColor-input-spacer">
      </div>
      <div class="AddNodeNameColor-wrapper-colors lxn-w100">
        <div @click="activeBoxIndex = 0;" class="AddNodeNameColor-color color1 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(0)" :class="isBoxActive(0)">
          <div class="AddNodeNameColor-selectedColor lxn-w100 lxn-h100 lxn-border-round">
          </div>
        </div>
        <div @click="activeBoxIndex = 1;" class="AddNodeNameColor-color color2 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(1)" :class="isBoxActive(1)">
          <div class="AddNodeNameColor-selectedColor lxn-w100 lxn-h100 lxn-border-round">
          </div>
        </div>
        <div @click="activeBoxIndex = 2;" class="AddNodeNameColor-color color3 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(2)" :class="isBoxActive(2)">
          <div class="AddNodeNameColor-selectedColor lxn-w100 lxn-h100 lxn-border-round">
          </div>
        </div>
        <div @click="activeBoxIndex = 3;" class="AddNodeNameColor-color color4 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(3)" :class="isBoxActive(3)">
          <div class="AddNodeNameColor-selectedColor lxn-w100 lxn-h100 lxn-border-round">
          </div>
        </div>
        <div @click="activeBoxIndex = 4;" class="AddNodeNameColor-color color5 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(4)" :class="isBoxActive(4)">
          <div class="AddNodeNameColor-selectedColor lxn-w100 lxn-h100 lxn-border-round">
          </div>
        </div>
      </div>
    </div>
    <div class="AddNodeNameColor-button lxn-margin-auto lxn-w100">
      <CustomButton @click="next" :bgColor="$store.state.themeMainColors[activeBoxIndex]" iconRight="verySecure" :iconRightColor="$store.state.themeMainColors[activeBoxIndex]" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
        {{$store.getters.language.texts.AddNodeNameColor_button}}
      </CustomButton>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import CustomCurve from '@/components/CustomCurve.vue'
import TopNav from '@/components/TopNav.vue'
import WrapperSvgTitleText from '@/components/addNewDevice/WrapperSvgTitleText.vue'
import CustomButton from '@/components/CustomButton.vue'
import CustomInput from '@/components/CustomInput.vue'
import Messaging from '@/statics/messaging.js'
import Logger from '@/statics/logger.js'


export default {
  name: 'AddNodeNameColor',
  components: {
    CustomCurve,
    TopNav,
    WrapperSvgTitleText,
    CustomButton,
    CustomInput
  },
  data: function () {
    return {
      NodeName: this.$store.state.tempNode.name || '',
      inputState: '',
      activeBoxIndex: this.$store.state.tempNode.color || 0,
    }
  },
  methods: {
    boxStyle: function (boxIndex) {
      return "background-color: " + this.$store.state.themeMainColors[boxIndex];
    },
    isBoxActive: function (boxIndex) {
      if(this.activeBoxIndex == boxIndex) {
        return 'active';
      }else{
        return '';
      }
    },
    goBack: function () {
      this.$router.go(-1);
    },
    next: function () {
      this.inputState = '';
      if(this.NodeName == ''){
        this.inputState = 'error';
        alert(this.$store.getters.language.texts.AddNodeNameColor_alert_nameEmpty);
      }else{
        this.$store.commit('SetTempNodeNameColor', {name: this.NodeName, color: this.activeBoxIndex});
        this.$store.commit('setAppBusy', true);
        var psk = this.$store.state.hubs[this.$store.state.tempNode.hubIndex].psk;
        var destinationUUID = this.$store.state.hubs[this.$store.state.tempNode.hubIndex].uuid;
        var nodeUUID = this.$store.state.scannedQR.uuid;
        var deviceType = this.$store.state.scannedQR.deviceType;
        var firmwareYear = this.$store.state.scannedQR.firmwareYear;
        var firmwareMonth = this.$store.state.scannedQR.firmwareMonth;
        var name = this.$store.state.tempNode.name;
        var color = this.$store.state.tempNode.color;

        var messagingHook = new Messaging(new Logger(false));
        messagingHook.init({
          psk: psk,
          destinationUUID: destinationUUID,
          sourceUUID: this.$store.state.user.uuid,
        });
        this.$store.dispatch('registerNode', {
            messagingHook: messagingHook,
            hubUUID: destinationUUID,
            nodeUUID: nodeUUID,
            nodeFallbackKey: this.$store.state.scannedQR.fallback,
            deviceType: deviceType,
            firmwareYear: firmwareYear,
            firmwareMonth: firmwareMonth,
        }).then( () => {
          var nodeContex = {
            name: name,
            color: color,
            uuid: nodeUUID,
            hubUUID: destinationUUID,
            deviceType: deviceType,
            firmwareYear: firmwareYear,
            firmwareMonth: firmwareMonth,
            isPaired: false,
          };
          this.$store.dispatch('addNode' + deviceType, nodeContex);
          this.$store.commit('setScannedQR', null);
          this.$store.commit('setTempNodeHubIndex', null);
          this.$store.commit('SetTempNodeNameColor', {name: null, color: null});
          this.$store.commit('saveState');
          this.$router.push('/AddNode-Success');
          this.$store.commit('setAppBusy', false);
        }).catch( () => {
          // TODO: handle not privileged here
          this.$router.push('/AddNode-HubNotFound');
          this.$store.commit('setAppBusy', false);
        });
      }
    }
  }
}
</script>

<style>
  .AddNodeNameColor-topCurve-wrapper {
    height: 200px;
  }
  .AddNodeNameColor-main-wrapper {
    width: calc(100% - 36px);
    margin-top: -150px;
    z-index: 1;
    background-color: #ffffff;
  }
  .AddNodeNameColor-wrapper-inputs {
    width: calc(100% - 36px);
    height: 148px;
    background-color: #ffffff;
    margin-top: 16px;
    padding-left: 16px;
    padding-right: 16px;
  }
  .AddNodeNameColor-input-spacer {
    height: 16px;
  }
  .AddNodeNameColor-wrapper-colors {
    height: 50px;
  }
  .AddNodeNameColor-color {
    width: calc((100% - 32px)/5);
    margin-left: 8px;
    padding: 5px;
  }
  .AddNodeNameColor-selectedColor {
    background-color: transparent;
    border-style: solid;
    border-color: #FFFFFF;
    border-width: 4px;
    opacity: 0;
  }
  .AddNodeNameColor-color.active .AddNodeNameColor-selectedColor {
    opacity: 1;
  }
  .AddNodeNameColor-color:last-child {
    width: calc((100% - 32px)/5);
    margin-left: 0;
  }
  .AddNodeNameColor-button {
    width: calc(100% - 36px);
    margin-bottom: 14px;
  }
	.AddNodeNameColor-st0 {
    fill: #ECECEC;
  }
	.AddNodeNameColor-st1 {
    fill: #53636C;
  }
	.AddNodeNameColor-st2 {
    fill: #1EA5DE;
  }
</style>
